// MUI Imports
import { useTheme } from '@mui/material/styles';

import type { CSSObject } from '@emotion/styled';
// Third-party Imports
import classnames from 'classnames';

// Type Imports
import type { ChildrenType } from '../../../@core/types';

// Config Imports
import themeConfig from '../../../configs/themeConfig';

// Hook Imports
import { useSettings } from '../../../@core/hooks/useSettings';

// Util Imports
import { horizontalLayoutClasses } from '../../utils/layoutClasses';

// Styled Component Imports
import StyledHeader from '../../styles/horizontal/StyledHeader';

type Props = ChildrenType & {
  overrideStyles?: CSSObject;
};

const Header = (props: Props) => {
  // Props
  const { children, overrideStyles } = props;

  // Hooks
  const { settings } = useSettings();
  const theme = useTheme();

  // Vars
  const { navbarContentWidth } = settings;

  const headerFixed = themeConfig.navbar.type === 'fixed';
  const headerStatic = themeConfig.navbar.type === 'static';
  const headerBlur = themeConfig.navbar.blur === true;
  const headerContentCompact = navbarContentWidth === 'compact';
  const headerContentWide = navbarContentWidth === 'wide';

  return (
    <StyledHeader
      theme={theme}
      overrideStyles={overrideStyles}
      className={classnames(horizontalLayoutClasses.header, {
        [horizontalLayoutClasses.headerFixed]: headerFixed,
        [horizontalLayoutClasses.headerStatic]: headerStatic,
        [horizontalLayoutClasses.headerBlur]: headerBlur,
        [horizontalLayoutClasses.headerContentCompact]: headerContentCompact,
        [horizontalLayoutClasses.headerContentWide]: headerContentWide,
      })}
    >
      {children}
    </StyledHeader>
  );
};

export default Header;
